<template>
    <v-container fluid class="grey lighten-5 my-0 px-0  py-0">
        <QAgencyBuildingSubmenu />
        <!-- Charts-->
        <v-row justify="space-between" align="stretch" class="mx-5" id="EverPlans">
            <v-col cols="12">
                <QAgentDirectoryTable title="Agent Directory" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import QAgencyBuildingSubmenu from '@/components/navigation/Submenus/QAgencyBuildingSubmenu.vue';
import QAgentDirectoryTable from '@/components/datatables/QAgentDirectoryTable.vue';

export default {
    name: "AgentDirectory",
    components: {
        QAgencyBuildingSubmenu,
        QAgentDirectoryTable
    }
};
</script>
